import Image from "next/image";
import styles from "../upsc-prefit-prelims-test-series/Prefit.module.css";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import Link from "next/link";
const Prefit = () => {
 
   const feestructure3 =[

    // {center: "Online",mode: "Batch 3 - Online", start: "16th Mar 2026",
    //       cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Upsc-Prefit-TestSeries-2026/AnnaNagar/Upsc-Prefit-TestSeries-B3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}> 
    //             <Image src={NewiconA} alt="download icon" width={35} height={35} className={`${styles.downloadicon}`}/>Click here</Link>),
    //       cont4:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/Upsc-Prefit-Brochure-2026/Tamilnadu/Upsc-Prefit-Brochure-B3-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}> 
    //             <Image src={NewiconA} alt="download icon" width={35} height={35} className={`${styles.downloadicon}`}/>Click here</Link>),
    //         pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=PREFIT 2026" target="_blank" rel="noopener noreferrer">
    //                 <button className={`${styles.normalbutton1} btn btn-danger`}>
    //                   Pay Now
    //                 </button>
    //             </a>)
    //         },


    ]

  return (
    <>

{/* <section  id="courseandfees">
    <div className="container pt-xl-4" >
        <div className='py-2' style={{backgroundColor: "#001e62"}}>
            <h2 className={`${styles.tabletitle}`}>UPSC Prelims Test Series 2026 | Prefit Test</h2>
        </div>
      <div className="row">
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} >Center</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} >Batch</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} >Starts on</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Schedule</div> 
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`}>Brochure</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} >Admission</div>
      </div>
                    
      {feestructure3.map((item,index)=>(
        <div className={`${styles.facultyborder4} row`}>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>

            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2  pt-md-3`}>{item.mode}</div>
                
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>

            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2 pb-md-2`}>{item.cont3}</div>

            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Brochure</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2 pb-md-2`}>{item.cont4}</div> 

            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-3`}>
            {item.pay}
        </div>
          <hr/>
        </div>
      ))} 
    </div>
</section>


<div className="container mb-3">
   <div className="row">
     <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-4">
       <div className={`${styles.facultyborder3} p-4 h-100`}>
       <div className='' style={{backgroundColor: "#001e62"}}>
         <p className={`${styles.tabletitle}`}>Exam Pattern </p>
        </div>

      <div className={`${styles.tablescroll} prelimstable`}>
       <table class="table">
            <thead className={`${styles.table1}`} >
                 <tr>
                    <td className={`${styles.tableheading}`}>Half Test<br /></td>
                    <td className={`${styles.tableheading}`}>Full Test<br /></td>
                 </tr>
            </thead>
            <tbody>
                 <tr className="pt-2">
                     <td className={`${styles.tablepara} border-0`}>50 Qns (1 hr)<br /></td>
                     <td className={`${styles.tablepara}`}>100 Qns (2 hr) </td>
                                     </tr> 
            </tbody>
        </table>
      </div>
     
       </div>
     </div>

     <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-4">
       <div className={`${styles.facultyborder3} p-4 h-100`}>
         <p className={`${styles.sectionsubtitle}`}>Fee</p>
         <div className="row">
           <div className="col-lg-4 col-5 col-md-6">
             <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>5,000/-</p>
           </div>
           <div className="col-lg-8 col-7 col-md-6">
             <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
           </div>
         </div>
         <div className="row pt-3">
           <div className="col-lg-4 col-5 col-md-6">
             <p className={`${styles.sectionredtitle}`}><b>₹</b>4,500/-</p>
           </div>
           <div className="col-lg-8 col-7 col-md-6">
             <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
           </div>
         </div>
       </div>
     </div>

     <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12 pt-5">
      
       <p className="pt-lg-0 pt-xl-3"><Link href="/upsc-prestorming-prelims-test-series"><button className={`${styles.normalbutton2}`} type="submit">Click here for Prestorming</button></Link></p>
      
     </div>

  </div>
</div> */}


</>
);
};

export default Prefit;